import PropTypes from 'prop-types';

const pageBlockPropType = (extendPropertiesType) => {
  return PropTypes.shape({
    pageBlockId: PropTypes.number,
    pageBlockTypeCode: PropTypes.string,
    pageBlockTitle: PropTypes.string,
    pageBlockDescriptionHtml: PropTypes.string,
    pageBlockLayoutType: PropTypes.shape({
      pageBlockLayoutTypeCode: PropTypes.string,
      pageBlockItemsPerLinePcViewCount: PropTypes.number,
      pageBlockItemsPerLineSpViewCount: PropTypes.number,
    }),
    extendProperties: extendPropertiesType
  }).isRequired;
}

export {
  pageBlockPropType,
};
